<div>
  <span class="state-label pr-10">Stav:</span>

  <a class="button active" (click)="opened = !opened">{{ case.caseStatus.name }}&nbsp;&nbsp;<i class="fa fa-chevron-circle-down"></i></a>

  <div *ngIf="opened" class="content-container bordered">
    <div *ngIf="!case.statusFlowLocked && 'CREATED' != case.pfkStatus">
      <a *ngFor="let actionButton of actionButtons" class="bordered-bottom p-10" (click)="actionButton.click ? actionButton.click() : undefined" uiSref="{{ actionButton.click ? '' : ('symap.project.cases.detail.' + actionButton.key) }}">
        <i class="fa {{ actionButton.icon }}"></i> {{ actionButton.name }}
      </a>

      <div *ngIf="!actionButtons || actionButtons.length === 0" class="text-center p-10">
        Stav nelze změnit
      </div>

      <div *ngIf="previousState && previousEnabled">
        <a (click)="onBack()" class="p-10"><i class="fa fa-step-backward"></i> Vrátit do stavu "{{ previousState }}"</a>
      </div>
    </div>

    <div *ngIf="case.statusFlowLocked">
      <div class="text-center p-10">
        Stav nelze změnit <br>
        <span class="disabled pt-7">Čeká se na zveřejnění smlouvy v registru smluv systémem Helios</span>
      </div>
    </div>

    <div *ngIf="'CREATED'==case.pfkStatus">
      <div class="text-center p-10">
        Stav nelze změnit <br>
        <span class="disabled pt-7">Není dokončena PFK v systému Helios.</span>
      </div>
    </div>
  </div>
</div>
